import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import { faHouse, faHouseUser } from '@fortawesome/free-solid-svg-icons';
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";
import Loader from "../common/Loader";

const OccupantsState = () => {

    const [occupants, setOccupants] = useState('NA');

    useEffect(() => {
        const controller = new AbortController();
        getDomusState();

        return () => {
            controller.abort();
        };
    }, []);

    const getDomusState = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/home/status', config);
            setOccupants(resp.data.occupants);
        } catch(err) {
            toast.error('API error getting occupants state');
        }
    };

    const toggleOccupants = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.post('/home/update-status', {"occupants": !occupants}, config);
            if (resp.status === 200) {
                setOccupants(!occupants)
            } else {
                toast.error("API error changing occupants state");
            }
        } catch(err) {
            toast.error('API error changing occupants state');
        }
    };

    const renderPresence = () => {
        if (occupants === 'NA') {
            return (
                <div id="user_state" className="tile-stats">
                    <h3>Presence</h3>
                    <div className="icon tile-icon--presence-away"><FontAwesomeIcon icon={faHouse} /></div>
                    <div id="occupants_loading">
                        <Loader size={20} />
                    </div>
                </div>
            );
        } else if (!occupants) {
            return (
                <button id="user_state" className="tile-stats tile-stats--interactive" type="button" onClick={toggleOccupants}>
                    <h3>Presence</h3>
                    
                    <div className="icon tile-icon--presence-away"><FontAwesomeIcon icon={faHouse} /></div>
                    <div className="count">AWAY</div>
                </button>
            );
        } else {
            return (
                <button id="user_state" className="tile-stats tile-stats--interactive" type="button" onClick={toggleOccupants}>
                    <h3>Presence</h3>
                    
                    <div className="icon tile-icon--presence-home"><FontAwesomeIcon icon={faHouseUser} /></div>
                    <div className="count">AT HOME</div>
                </button>
            );
        }
    };

    return (
        <div className="animated flipInY col-lg-8 col-md-8 col-sm-6 col-xs-12">
           { renderPresence() }
        </div>
    );
};

export default OccupantsState;
